export class CreateSupplierModel {
  public enderecos: address[] = []
  public contatos: contact[] = []
  public documento_fiscal: number[] = []
  public forma_pagamento: formPayment[] = []
  public dados_bancarios: bankingDetails[] = []
}
export class EditSupplierModel {
  public id = 0
  public descricao = ''
}

export class DeleteSupplierModel {
  public id = 0
  public descricao = ''
}

export class SearchSupplierModel {
  public descricao = ''
}

export class CreateSupplierResponse {
  public response: any
}
export class EditSupplierResponse {
  public response: any
}
export class DeleteSupplierResponse {
  public response: any
}
export class PagedSupplierResponse {
  public response: any
}

/*         Supplier Legal                */

export class CreateSupplierLegalModel {
  public fornecedor: supplierLegal = new supplierLegal()
  public enderecos: address[] = []
  public contatos: contact[] = []
  public documento_fiscal: number[] = []
  public forma_pagamento: formPayment[] = []
  public dados_bancarios: bankingDetails[] = []
  public responsaveis: responsible[] = []
  public files: file[] = []
}
export class EditSupplierLegalModel {
  public id = 0
  public descricao = ''
}

export class DeleteSupplierLegalModel {
  public id = 0
  public descricao = ''
}

export class UploadDocSupplierModel {
  public arquivo: uploadFile = new uploadFile()
}

export class SearchSupplierLegalModel {
  public nomeFantasia = ''
  public razaoSocial = ''
  public cnpj = ''
  public inscricaoEstadual = ''
  public inscricaoMunicipal = ''
}

export class CreateSupplierLegalResponse {
  public response: any
}
export class EditSupplierLegalResponse {
  public response: any
}
export class DeleteSupplierLegalResponse {
  public response: any
}
export class PagedSupplierLegalResponse {
  public response: any
}

/*         Supplier Natural                */

export class CreateSupplierNaturalModel {
  public fornecedor: supplierNatural = new supplierNatural()
  public enderecos: address[] = []
  public contatos: contact[] = []
  public documento_fiscal: number[] = []
  public forma_pagamento: formPayment[] = []
  public dados_bancarios: bankingDetails[] = []
}
export class EditSupplierNaturalModel {
  public id = 0
  public descricao = ''
}

export class DeleteSupplierNaturalModel {
  public id = 0
  public descricao = ''
}

export class SearchSupplierNaturalModel {
  public descricao = ''
}

export class CreateSupplierNaturalResponse {
  public response: any
}
export class EditSupplierNaturalResponse {
  public response: any
}
export class DeleteSupplierNaturalResponse {
  public response: any
}
export class PagedSupplierNaturalResponse {
  public response: any
}

///////////////////////////////////////////////////////////////

class supplierLegal {
  public id?: number
  public nome = ''
  public cnpj = ''
  public razao_social = ''
  public insc_municipal = ''
  public insc_estadual = ''
}

class supplierNatural {
  public nome = ''
  public cpf = ''
}

class address {
  public tipo_endereco_id = 0
  public cep = ''
  public logradouro = ''
  public bairro = ''
  public numero = ''
  public complemento = ''
  // public referencia: string = ''
  public cidade = ''
  public estado = ''
  // public latitude: string = ''
  // public longitude: string = ''
  public pais = ''
}

class contact {
  public tipoContatoId = 0
  public descricao = ''
}

class formPayment {
  public tipo_pagamento_id = 0
  public prazo = ''
}

class bankingDetails {
  public banco = 0
  public agencia = ''
  public conta = ''
  public pix = ''
}

class responsible {
  public nome = ''
  public email = ''
  public telefone = ''
}

class uploadFile {
  public fornecedorId = 0
  public tipoDocId = 0
  public descricao = ''
  public FileObject: File | null = null
}

export class uploadDocSupplier extends UploadDocSupplierModel {
  public toFormData(): FormData {
    const formData = new FormData()
    formData.append('Descricao', this.convertString(this.arquivo.descricao))
    formData.append('TipoDocId', this.convertString(this.arquivo.tipoDocId))
    formData.append('FornecedorId', this.convertString(this.arquivo.fornecedorId))
    if (this.arquivo.FileObject) {
      formData.append('Arquivo', this.arquivo.FileObject)
    }

    return formData
  }
  private convertString(value: any): string {
    return value !== undefined && value !== null ? value.toString() : ''
  }
}

export class CreateSupplierFormModel extends CreateSupplierLegalModel {
  public toFormData(): FormData {
    const formData = new FormData()

    // FornecedorRegisterObj
    formData.append('Fornecedor.Nome', this.convertString(this.fornecedor.nome))
    formData.append('Fornecedor.razao_social', this.convertString(this.fornecedor.razao_social))
    formData.append('Fornecedor.insc_municipal', this.convertString(this.fornecedor.insc_municipal || ''))
    formData.append('Fornecedor.insc_estadual', this.convertString(this.fornecedor.insc_estadual || ''))
    formData.append('Fornecedor.cnpj', this.convertString(this.fornecedor.cnpj))

    // Enderecos
    if (this.enderecos) {
      for (let i = 0; i < this.enderecos.length; i++) {
        const endereco = this.enderecos[i]
        formData.append(`Enderecos[${i}].tipo_endereco_id`, this.convertString(endereco.tipo_endereco_id))
        formData.append(`Enderecos[${i}].cep`, this.convertString(endereco.cep))
        formData.append(`Enderecos[${i}].logradouro`, this.convertString(endereco.logradouro))
        formData.append(`Enderecos[${i}].numero`, this.convertString(endereco.numero))
        formData.append(`Enderecos[${i}].complemento`, this.convertString(endereco.complemento))
        formData.append(`Enderecos[${i}].bairro`, this.convertString(endereco.bairro))
        formData.append(`Enderecos[${i}].estado`, this.convertString(endereco.estado))
        formData.append(`Enderecos[${i}].cidade`, this.convertString(endereco.cidade))
        formData.append(`Enderecos[${i}].pais`, this.convertString(endereco.pais || 'Brasil'))
      }
    }

    // Contatos

    for (let i = 0; i < this.contatos.length; i++) {
      const contato = this.contatos[i]
      if (contato.tipoContatoId >= 0 && contato.descricao) {
        formData.append(`Contatos[${i}].tipoContatoId`, this.convertString(contato.tipoContatoId))
        formData.append(`Contatos[${i}].descricao`, this.convertString(contato.descricao))
      }
    }


    // Documento Fiscal (apenas o primeiro item)
    formData.append('documento_fiscal', this.convertString(this.documento_fiscal[0]))

    // Forma Pagamento
    if (this.forma_pagamento) {
      for (let i = 0; i < this.forma_pagamento.length; i++) {
        const pagamento = this.forma_pagamento[i]
        formData.append(`forma_pagamento[${i}].tipo_pagamento_id`, this.convertString(pagamento.tipo_pagamento_id))
        formData.append(`forma_pagamento[${i}].prazo`, this.convertString(pagamento.prazo))
      }
    }

    // Dados Bancários
    if (this.dados_bancarios) {
      for (let i = 0; i < this.dados_bancarios.length; i++) {
        const banco = this.dados_bancarios[i]
        formData.append(`dados_bancarios[${i}].banco`, this.convertString(banco.banco))
        formData.append(`dados_bancarios[${i}].agencia`, this.convertString(banco.agencia))
        formData.append(`dados_bancarios[${i}].conta`, this.convertString(banco.conta))
        formData.append(`dados_bancarios[${i}].pix`, this.convertString(banco.pix))
      }
    }

    // Responsáveis
    if (this.responsaveis) {
      for (let i = 0; i < this.responsaveis.length; i++) {
        const resp = this.responsaveis[i]
        formData.append(`Responsaveis[${i}].nome`, this.convertString(resp.nome))
        formData.append(`Responsaveis[${i}].email`, this.convertString(resp.email))
        formData.append(`Responsaveis[${i}].telefone`, this.convertString(resp.telefone))
      }
    }

    // Documentos/Arquivos
    if (this.files) {
      for (let i = 0; i < this.files.length; i++) {
        const doc = this.files[i]
        if (doc.tipoDocId >= 0 && doc.descricao && doc.FileObject) {
          formData.append(`Documentos[${i}].tipoDocId`, this.convertString(doc.tipoDocId))
          formData.append(`Documentos[${i}].descricao`, this.convertString(doc.descricao))
          formData.append(`Documentos[${i}].arquivo`, doc.FileObject)
        }
      }
    }

    return formData
  }

  private convertString(value: any): string {
    return value !== undefined && value !== null ? value.toString() : ''
  }
}


class file {
  public tipoDocId = 0
  public descricao = ''
  public FileObject: File | null = null
}

